<template>
  <div class="payment-layout">

    <div v-if="userId == null">
      <ChecklLogin />
    </div>
    <div v-else>
      <div class="container-list">
        <div class="title-payment">Unpaid Bills</div>

        <v-skeleton-loader v-if="isLoading" class="skeleton-loader" type="list-item-three-line"
          height="70"></v-skeleton-loader>
        <span v-for="payment in unpaidBills" :key="payment.id" @click="routeTo('PaymentDetail', payment)"
          v-show="!isLoading">
          <Bill :payment="payment" style="background: #FFD6D6; border: none;"></Bill>
        </span>

      </div>

      <div class="title-payment" style="color: var(--theme-one);">Paid Bills</div>

      <v-skeleton-loader v-if="isLoading" type="list-item-three-line"></v-skeleton-loader>
      <span v-for="payment in sortedPaymentsFilteredByType" :key="payment.id" @click="routeTo('PaymentDetail', payment)"
        v-show="!isLoading">
        <Bill :payment="payment"></Bill>
      </span>
    </div>



  </div>
</template>

<script>
import Bill from '../components/Bill.vue'
import axios from 'axios';
import ChecklLogin from "../components/CheckLogin.vue"

export default {
  name: "Payment",
  components: {
    Bill,
    ChecklLogin
  },
  data() {
    return {
      // payments: [
      //   { id: 1, date: '1 Oct 2023', BillDueDate: '07 Oct 2023', PayDate: "03 Oct 2023", time: '10:10 AM', type: 1, total: 3500 },
      //   { id: 2, date: '1 Jun 2023', BillDueDate: '07 Jun 2023', PayDate: "05 Jun 2023", time: '09:10 AM', type: 0, total: 2500 },
      //   { id: 3, date: '1 May 2023', BillDueDate: '07 May 2023', PayDate: "04 May 2023", time: '09:28 PM', type: 0, total: 2000 },
      //   { id: 4, date: '1 Apr 2023', BillDueDate: '07 Apr 2023', PayDate: "02 Apr 2023", time: '08:28 AM', type: 0, total: 5100 },
      //   { id: 5, date: '1 Mar 2023', BillDueDate: '07 Mar 2023', PayDate: "06 Mar 2023", time: '09:24 AM', type: 0, total: 3100 },
      //   { id: 6, date: '1 Aug 2023', BillDueDate: '07 Aug 2023', PayDate: "07 Aug 2023", time: '09:48 AM', type: 0, total: 3100 },
      //   { id: 7, date: '1 Sep 2023', BillDueDate: '07 Sep 2023', PayDate: "05 Sep 2023", time: '09:30 AM', type: 0, total: 4200 },
      // ],
      payments: [],
      isLoading: true,
      userId: null,
    }
  },
  methods: {
    routeTo(route, billDetail) {
      if (!route) return
      console.log(route)
      this.$router.push({ name: route, query: { id: billDetail.id } })
    },
    async fetchData() {
      try {
        this.userId = localStorage.getItem('user_id');
        console.log(this.userId);
        // const response = await axios.get('https://windee-cms.ksta.co/api/get-payment-all');
        let response = await this.$apiFire('Payment/onGetPaymentList', parseInt(this.userId))  //User id
        console.log('apitest ', response);
        this.payments = response;
        this.isLoading = false;
      } catch (error) {
        console.log(error);
      }
    }

  },
  computed: {
    unpaidBills: function () {
      return this.payments.filter(function (payment) {
        return payment.status === "0";
      })
    },
    sortedPaymentsFilteredByType: function () {
      return this.payments.filter(function (payment) {
        return payment.status === "1";
      }).slice().sort(function (a, b) {
        let dateA = new Date(a.date);
        let dateB = new Date(b.date);
        return dateB - dateA;
      });
    },
  },
  created() {
    this.fetchData();
  },
  mounted() {

  }
}
</script>

<style scoped>
.payment-layout {
  padding: 8px;
}

.container-list {
  margin-bottom: 20px;
}

.title-payment {
  font-size: 16px;
  font-weight: 500;
  color: #686868;
}
</style>